<app-page-header title="Promotion Export" description="Export a promotion's data for a selected buying group."></app-page-header>
<dx-box direction="row" width="100%" height="75">
  <dxi-item [ratio]="0" baseSize="200">
    <div class="dx-fieldset">
      <div class="dx-fieldset-label">Promotion</div>
      <dx-lookup
      [dataSource]="promotionPeriods"
      [valueExpr]="'id'"
      [displayExpr]="'promotion_name'"
      (onValueChanged)="setPromotionPeriodId($event)"></dx-lookup>
    </div>
    <dxi-validation-rule type="required" message="Promotion is required"></dxi-validation-rule>
  </dxi-item>
  <dxi-item [ratio]="0" baseSize="150">
    <div class="dx-fieldset">
      <div class="button-spacer"></div>
        <dx-button
          stylingMode="contained"
          text="Load"
          type="default"
          [width]="120"
          (onClick)="getPromotionExportData()"
        ></dx-button>
      </div>
  </dxi-item>
  <dxi-item [ratio]="0" baseSize="800">
    <div class="dx-fieldset">
      <div class="dx-field-label">Notes</div>
        <dx-text-area
          class="dx-field-value"
          [height]="70"
          [width]="800"
          value="This export is currently used for Thirsty Camel ONLY and assumes that data is exported only for Large and NSWBR buying groups. 
EDLP Promotion names must start with 'EDV'. Promotion description must start with either 'Floor', 'Beer Week 1' or 'Beer Week 2'. 
Any deviations from this could result in malformed data or an error."
          [inputAttr]="{ 'aria-label': 'Notes' }"
        >
        </dx-text-area>
      </div>          
  </dxi-item>
</dx-box>
<div class="grid">
  <dx-data-grid #promotionExportGrid
      [dataSource]="dataSource"
      [remoteOperations]="false"
      [allowColumnReordering]="true"
      [rowAlternationEnabled]="true"
      [height]="'100%'"
      [allowColumnResizing]="true"
      [columnResizingMode]="'widget'"
      [showColumnLines]="true"
      [wordWrapEnabled]="true"
      [columnAutoWidth]="true"
      [focusedRowEnabled]="true"
      keyExpr="id"
      [(customizeColumns)]="customizeColumns"
      (onExporting)="onExporting($event)"
  >
    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="detailsLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
>
</dx-load-panel>
